var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vl-form-column',{attrs:{"width":"12"}},[_c('ItemList',{attrs:{"validator-rules":"","add-element-text":_vm.buttonCopy,"value":_vm.value || []},on:{"input":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }